// import React, { useState, useEffect } from "react";
// import toast from "react-hot-toast";
// import { useNavigate, useParams } from "react-router-dom";
// import labServices from "../../../Services/labtestservices"; // Make sure this service points to your API

// const AddLabtest = () => {
//   // Function to get today's date in YYYY-MM-DD format
//   const getCurrentDate = () => {
//     const today = new Date();
//     return today.toISOString().split("T")[0]; // format YYYY-MM-DD
//   };

//   const { id } = useParams(); // Get id from URL if updating
//   const navigate = useNavigate();

//   // State for lab test data
//   const [labTestData, setLabTestData] = useState({
//     name: "",
//     price: 0,
//     discount: 0,
//     date: getCurrentDate(),
//     purchase_price: 0,
//   });

//   // Fetch existing lab test data if updating
//   useEffect(() => {
//     if (id) {
//       const fetchLabTest = async () => {
//         try {
//           const response = await labServices.fetchById(id);
//           if (response && response.service) {
//             setLabTestData({
//               name: response.service.name || "",
//               price: response.service.price ?? 0,
//               discount: response.service.discount ?? 0,
//               date: response.service.date
//                 ? response.service.date.split("T")[0]
//                 : getCurrentDate(),
//               purchase_price: response.service.purchase_price ?? 0,
//             });
//           }
//         } catch (error) {
//           console.error(error);
//           toast.error("Error fetching Lab Test data.");
//         }
//       };
//       fetchLabTest();
//     }
//   }, [id]);

//   // Handle input changes
//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setLabTestData((prev) => ({
//       ...prev,
//       [name]: value,
//     }));
//   };

//   // Handle form submit
//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     try {
//       if (id) {
//         await labServices.update(id, labTestData);
//         toast.success("Lab Test updated successfully!");
//       } else {
//         await labServices.create(labTestData);
//         toast.success("Lab Test added successfully!");
//       }
//       navigate("/account/Labtest/labtest"); // Redirect to lab test list page
//     } catch (error) {
//       console.error(error);
//       toast.error("Error saving Lab Test data.");
//     }
//   };

//   return (
//     <form onSubmit={handleSubmit} className="w-[90%] m-auto">
//       <h1 className="m-[30px] text-center text-[#F07F1B] font-[900] text-[30px]">
//         {id ? "Update Lab Test" : "Add Lab Test"}
//       </h1>

//       <div className="grid grid-cols-3 gap-10 my-[20px] mt-20">
//         <div>
//           <label className="font-semibold text-sm">Lab Test Name</label>
//           <input
//             name="name"
//             value={labTestData.name}
//             onChange={handleChange}
//             required
//             className="w-full bg-gray-50 p-3 text-sm border-b-[3px] rounded-lg focus:outline-none focus:border-[#F07F1B] mt-1"
//           />
//         </div>

//         <div>
//           <label className="font-semibold text-sm">Price</label>
//           <input
//             type="number"
//             name="price"
//             value={labTestData.price}
//             onChange={handleChange}
//             required
//             className="w-full bg-gray-50 p-3 text-sm border-b-[3px] rounded-lg focus:outline-none focus:border-[#F07F1B] mt-1"
//           />
//         </div>

//         <div>
//           <label className="font-semibold text-sm">Discount</label>
//           <input
//             type="number"
//             name="discount"
//             value={labTestData.discount}
//             onChange={handleChange}
//             className="w-full bg-gray-50 p-3 text-sm border-b-[3px] rounded-lg focus:outline-none focus:border-[#F07F1B] mt-1"
//           />
//         </div>

//         <div>
//           <label className="font-semibold text-sm">Purchase Date</label>
//           <input
//             type="date"
//             name="date"
//             value={labTestData.date}
//             onChange={handleChange}
//             required
//             className="w-full bg-gray-50 p-3 text-sm border-b-[3px] rounded-lg focus:outline-none focus:border-[#F07F1B] mt-1"
//           />
//         </div>

//         <div>
//           <label className="font-semibold text-sm">Purchase Price</label>
//           <input
//             type="number"
//             name="purchase_price"
//             value={labTestData.purchase_price}
//             onChange={handleChange}
//             required
//             className="w-full bg-gray-50 p-3 text-sm border-b-[3px] rounded-lg focus:outline-none focus:border-[#F07F1B] mt-1"
//           />
//         </div>
//       </div>

//       <div className="text-center my-[30px] mt-10">
//         <button
//           type="submit"
//           className="bg-white text-[#F07F1B] font-semibold shadow-lg border hover:bg-[#F07F1B] hover:text-white py-2 px-8 rounded-full duration-300"
//         >
//           {id ? "Update Data" : "Add Lab Test"}
//         </button>
//       </div>
//     </form>
//   );
// };

// export default AddLabtest;


import React, { useState, useEffect } from "react";
import toast from "react-hot-toast";
import { useNavigate, useParams } from "react-router-dom";
import labServices from "../../../Services/labtestservices";

// ── Reusable components ──────────────────────────────────────
const SectionLabel = ({ children }) => (
  <p className="text-[11px] uppercase tracking-widest font-[500] text-gray-400 mb-3 mt-6">
    {children}
  </p>
);

const InputField = ({ label, prefix, ...props }) => (
  <div className="flex flex-col gap-1">
    <label className="text-[12px] font-[500] text-gray-500">{label}</label>
    <div className="relative">
      {prefix && (
        <span className="absolute left-3 top-1/2 -translate-y-1/2 text-[12px] text-gray-400">
          {prefix}
        </span>
      )}
      <input
        {...props}
        className={`w-full ${prefix ? "pl-8" : "px-3"} pr-3 py-2 text-[13px] text-gray-800 bg-white border border-gray-200 rounded-lg outline-none hover:border-orange-200 focus:border-orange-400 focus:ring-2 focus:ring-orange-100`}
      />
    </div>
  </div>
);

const AddLabtest = () => {
  const getCurrentDate = () => {
    const today = new Date();
    return today.toISOString().split("T")[0];
  };

  const { id } = useParams();
  const navigate = useNavigate();

  const [labTestData, setLabTestData] = useState({
    name: "",
    price: 0,
    discount: 0,
    date: getCurrentDate(),
    purchase_price: 0,
  });

  useEffect(() => {
    if (id) {
      const fetchLabTest = async () => {
        try {
          const response = await labServices.fetchById(id);
          if (response && response.service) {
            setLabTestData({
              name: response.service.name || "",
              price: response.service.price ?? 0,
              discount: response.service.discount ?? 0,
              date: response.service.date
                ? response.service.date.split("T")[0]
                : getCurrentDate(),
              purchase_price: response.service.purchase_price ?? 0,
            });
          }
        } catch (error) {
          console.error(error);
          toast.error("Error fetching Lab Test data.");
        }
      };
      fetchLabTest();
    }
  }, [id]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setLabTestData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      if (id) {
        await labServices.update(id, labTestData);
        toast.success("Lab Test updated successfully!");
      } else {
        await labServices.create(labTestData);
        toast.success("Lab Test added successfully!");
      }
      navigate("/account/Labtest/labtest");
    } catch (error) {
      console.error(error);
      toast.error("Error saving Lab Test data.");
    }
  };

  return (
    <div className="bg-gray-50 flex items-start justify-center py-10 px-4">
      <div className="w-full max-w-[1400px]">
        <div className="bg-white rounded-2xl border border-gray-200 shadow-sm overflow-hidden">

          {/* ── Header ── */}
          <div className="bg-gray-800 px-8 py-5">
            <h1 className="text-white text-[18px] font-[500] tracking-tight">
              {id ? "Update Lab Test" : "Add Lab Test"}
            </h1>
            <p className="text-gray-400 text-[12px] mt-0.5">
              Fill in all fields to register the lab test record
            </p>
          </div>

          <form onSubmit={handleSubmit}>
            <div className="px-8 py-6">

              {/* ── Section 1: Basic Info ── */}
              <SectionLabel>Basic Information</SectionLabel>
              <div className="grid grid-cols-2 gap-4">
                <InputField
                  label="Lab Test Name"
                  type="text"
                  name="name"
                  placeholder="e.g. Complete Blood Count"
                  value={labTestData.name}
                  onChange={handleChange}
                  required
                />
                <InputField
                  label="Purchase Date"
                  type="date"
                  name="date"
                  value={labTestData.date}
                  onChange={handleChange}
                  required
                />
              </div>

              {/* ── Section 2: Pricing ── */}
              <SectionLabel>Pricing</SectionLabel>
              <div className="grid grid-cols-3 gap-4">
                <InputField
                  label="Purchase Price"
                  type="number"
                  name="purchase_price"
                  placeholder="0"
                  prefix="Rs."
                  value={labTestData.purchase_price}
                  onChange={handleChange}
                  required
                />
                <InputField
                  label="Price"
                  type="number"
                  name="price"
                  placeholder="0"
                  prefix="Rs."
                  value={labTestData.price}
                  onChange={handleChange}
                  required
                />
                <InputField
                  label="Discount in Percent"
                  type="number"
                  name="discount"
                  placeholder="0"
                  value={labTestData.discount}
                  onChange={handleChange}
                />
              </div>

              {/* ── Footer ── */}
              <div className="border-t border-gray-100 mt-8 pt-6 flex items-center justify-between">
                <button
                  type="button"
                  onClick={() => navigate("/account/Labtest/labtest")}
                  className="text-[13px] text-gray-400 hover:text-gray-600 transition-colors font-[500]"
                >
                  ← Cancel
                </button>
                <button
                  type="submit"
                  className="relative overflow-hidden bg-gray-800 text-white text-[13px] font-[500] px-6 py-2.5 rounded-lg border border-gray-300 shadow-md hover:shadow-gray-200 hover:scale-[1.03] active:scale-[0.97] transition-all duration-300 before:absolute before:inset-0 before:-translate-x-full hover:before:translate-x-full before:bg-white/20 before:transition-transform before:duration-500"               
                >
                  {id ? "Update Lab Test →" : "Save Lab Test →"}
                </button>
              </div>

            </div>
          </form>
        </div>

        <p className="text-center text-[12px] text-gray-400 mt-4">
          All fields marked as required must be filled before saving.
        </p>
      </div>
    </div>
  );
};

export default AddLabtest;